<nav class="nav-background navbar_02 navbar_01 py-2 px-2 w-auto uxStyle">
   
    <div class="mx-auto">
                <app-cosy-html [sessionID]="sessionID"  
                               [isFromRibbon]="isFromRibbon"  
                               [ieList]="ie.InterfaceElements" 
                               [downloadFile]="downloadFile" 
                               [cosyFormInit] = "cosyFormInit"
                               (loadHistory)="loadHistorytoBreadCrumb($event)" 
                               [breadCrumb]="breadCrumb">
                 </app-cosy-html>
    </div>     
</nav>

